<div fxLayout.lt-lg="column" fxLayout.gt-md="row" fxFlex="noshrink" fxLayoutAlign="center center" fxLayoutAlign.gt-md="space-around center" style="width: 100%">
    <mat-card class="cardPanel" fxFlex.gt-md="40">
        <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" style="margin-bottom: 1em;">
                <mat-icon class="large">wifi_off</mat-icon>
                <h2 class="messageHeader">System Currently Unavailable</h2>
            </div>
            <p>
                We're sorry, but the Multiple Pathways Education application is currently offline and unavailable. We apologize for
                the inconvenience. This page will continue to periodically check the system status, and if the system returns
                online and becomes available again, you will be taken to the login form directly. Thank you for your patience.
            </p>
            <p style="margin-top: 25px; margin-bottom: 5px">Time until next check:</p>
            <mat-progress-bar mode="determinate" [value]="(TimerCount * 100.0) / TimerMax" color="primary"> </mat-progress-bar>
        </mat-card-content>
    </mat-card>
</div>
